import styled from 'styled-components';
import { Modal } from 'takeat-design-system-ui-kit';

export const ReviewsModalContainer = styled(Modal)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  height: fit-content;
  max-width: 780px;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  h1 {
    margin: 0;
    color: ${({ theme }) => theme.colors.neutral.darker};
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 133.333% */
    letter-spacing: var(--Headline-Small-Tracking, 0px);
  }

  svg {
    cursor: pointer;
    font-size: 24px;
    fill: ${({ theme }) => theme.colors.neutral.dark};
  }
`;

export const ModalContent = styled.div`
  table {
    width: 100%;
    border-collapse: collapse;
    border-radius: 12px;
    box-shadow: ${({ theme }) => theme.shadows.lighter};

    thead,
    tbody {
      display: block;
    }

    tbody {
      max-height: 45dvh;
      overflow-y: auto;
    }

    tr {
      display: table;
      width: 100%;
    }

    td,
    th {
      width: 25%;
      text-align: center;
      padding: 12px 16px;
    }

    th {
      background-color: ${({ theme }) => theme.colors.neutral.lighter};
      color: ${({ theme }) => theme.colors.neutral.darker};
      font-family: Poppins;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px; /* 142.857% */
      letter-spacing: 0.1px;

      &:first-child {
        border-top-left-radius: 12px;
      }

      &:last-child {
        border-top-right-radius: 12px;
      }
    }

    td {
      color: ${({ theme }) => theme.colors.neutral.darker};
      font-family: Poppins;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px; /* 142.857% */
      letter-spacing: 0.1px;
    }
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  svg {
    font-size: 24px;
    fill: ${({ theme }) => theme.colors.yellow.default};
  }
`;
